import { UpsertProspectRequestBody, UpsertProspectResponseBody } from '@boltenergy-be/shared'
import { NextApiResponseBody } from 'types/bolt-api/request'

export const upsertProspect = async (body: UpsertProspectRequestBody): Promise<NextApiResponseBody<UpsertProspectResponseBody | null>> => {
  try {
    const res = await fetch(`/api/registrations/prospects`, {
      method: 'POST',
      body: JSON.stringify(body)
    })

    return (await res.json()) as NextApiResponseBody<UpsertProspectResponseBody | null>
  } catch (error) {
    return {
      success: false,
      data: null,
      message: error?.message || 'upsertProspect request failed'
    }
  }
}
